import { initialState, selectUuid } from '../redux/slicers/admin/curatorSlicer';

import { getAppState } from '../redux/store';
import { intersection } from 'lodash';
import { openDB } from 'idb';
import { selectLocalFileUrlsActive } from '../redux/slicers/admin/curatorDebuggerSlicer';
import { v4 as uuidv4 } from 'uuid';

const FILE_KEY = {
  PROJECT_ZIP: 'projectZip',
};

const TEMP_STORE_NAME = `temp__${uuidv4()}`;

const INDEX = {
  CURATOR_INDEX: 'curatorUuidIndex',
};

export const STORE = {
  PROPS: 'props',
  MATERIALS: 'materials',
  MATERIAL_TEXTURES_OLD: 'materialTexturesOld',
  TEXTURES: 'textures',
  LAYOUTS: 'layouts',
  FILES: 'files',
  TEMP_FILES: 'tempFiles',
  PROJECT_AUTOSAVE: 'projectAutosave',
  UPLOAD_FILES: 'uploadFiles',
};
export const idb = {
  curator: openDB('LiveFurnishCurator', 6, {
    blocked: () => {
      // TODO: handle this case when first upgrade will be needed
      console.log(`Please close this app opened in other browser tabs.`);
    },
    blocking: () => {
      // TODO: handle this case when first upgrade will be needed
      console.log(`App is outdated, please close this tab`);
    },
    upgrade: (db, oldVersion, newVersion, transaction) => {
      // TOOD: handle db upgrades when it's needed
      for (let version = oldVersion; version < newVersion; version++) {
        switch (version) {
          case 0:
            upgradeCuratorFromV0toV1();
            break;
          case 1:
            upgradeCuratorFromV1toV2();
            break;
          case 2:
            upgradeCuratorFromV2toV3();
            break;
          case 3:
            // This fixes bug
            upgradeCuratorFromV3toV4();
            break;
          case 4:
            upgradeCuratorFromV4toV5();
            break;
          case 5:
            upgradeCuratorFromV5toV6();
            break;
          default:
            console.error('unknown db version');
        }
      }

      function upgradeCuratorFromV0toV1() {
        db.createObjectStore(STORE.LAYOUTS, { keyPath: 'id' });
        db.createObjectStore(STORE.PROPS, { keyPath: 'id' });
        db.createObjectStore(STORE.MATERIALS, { keyPath: 'id' });
        db.createObjectStore(STORE.TEXTURES, { keyPath: 'id' });
      }

      function upgradeCuratorFromV1toV2() {
        db.createObjectStore(STORE.FILES, { keyPath: 'id' });
      }

      function upgradeCuratorFromV2toV3() {
        db.createObjectStore(STORE.MATERIAL_TEXTURES_OLD, { keyPath: 'id' });
      }

      function upgradeCuratorFromV3toV4() {
        // bugfix
        db.objectStoreNames;

        const stores = [
          STORE.PROPS,
          STORE.MATERIALS,
          STORE.LAYOUTS,
          STORE.FILES,
          STORE.MATERIAL_TEXTURES_OLD,
          STORE.TEXTURES,
        ];

        const existingNames = [...db.objectStoreNames];
        stores.forEach((storeName) => {
          const exist = existingNames.includes(storeName);
          if (exist) return;
          db.createObjectStore(storeName, { keyPath: 'id' });
        });
      }

      function upgradeCuratorFromV4toV5() {
        const tempFilesStore = db.createObjectStore(STORE.TEMP_FILES, { keyPath: 'id' });
        tempFilesStore.createIndex(INDEX.CURATOR_INDEX, 'curatorUuid', { unique: false });
      }

      function upgradeCuratorFromV5toV6() {
        const projectAutosaveStore = db.createObjectStore(STORE.PROJECT_AUTOSAVE, { keyPath: 'id' });
        projectAutosaveStore.createIndex(INDEX.CURATOR_INDEX, 'curatorUuid', { unique: false });
      }
    },
  }),
};

export const getCuratorDB = () => idb.curator;

window.getCuratorDB = getCuratorDB;

// export const add
export const updateAsset = async (storeName, data) => {
  const db = await getCuratorDB();
  await db.put(storeName, data);
};

const assetStore = {};

export const getAsset = async (storeName, id) => {
  // if (!assetStore[storeName]) {
  //   assetStore[storeName] = {};
  // }

  // if (assetStore[storeName][id]) {
  //   return assetStore[storeName][id];
  // }

  const db = await getCuratorDB();
  const asset = db.get(storeName, id);
  asset.IDB_ITEM = true;

  // assetStore[storeName][id] = asset;
  return asset;
};

export const deleteAsset = async (storeName, id) => {
  const db = await getCuratorDB();
  db.delete(storeName, id);
};

export const deleteTexture = async (id) => {
  await deleteAsset(STORE.TEXTURES, id);
};

const objectUrlStore = {}; // key = `{store}_{id}
window.objectUrlStore = objectUrlStore;

const removeItemFromObjectUrlStore = (storeName, id) => {
  const urlId = `${storeName}_${id}`;
  const url = objectUrlStore[urlId];
  if (url) {
    URL.revokeObjectURL(url);
    delete objectUrlStore[urlId];
  }
};

export const removeMaterialUrlFromObjectUrlStore = (id) => {
  removeItemFromObjectUrlStore(STORE.MATERIALS, id);
};

export const clearAllData = async () => {
  const db = await getCuratorDB();
  await Promise.all(
    Object.values(STORE).map((storeName) => {
      return db.clear(storeName);
    })
  );
};

const normalizeAsset = (asset, storeName) => {
  if (!asset) return asset;

  // TODO: add this url to some store and revoke it later so we don't keep it in memory
  const urlId = `${storeName}_${asset.id}`;
  const urlIdDoorWindow = `${storeName}_${asset.id}_doorwindow`
  if (!objectUrlStore[urlId]) {
    const localFileUrlsAcive = selectLocalFileUrlsActive(getAppState());

    if (localFileUrlsAcive) {
      objectUrlStore[urlId] = URL.createObjectURL(asset.file);
    } else {
      objectUrlStore[urlId] = asset.originalFileUrl; // URL.createObjectURL(asset.file);
    }
    if (asset?.file_window_door) {
      if (localFileUrlsAcive) {
        objectUrlStore[urlIdDoorWindow] = URL.createObjectURL(asset.file_window_door);
      } else {
        objectUrlStore[urlIdDoorWindow] = asset.originalWindowDoorFileUrl;
      }
    }
  }

  if (asset?.file_window_door) {
    asset.file_window_door = objectUrlStore[urlIdDoorWindow]
  }
  asset.file = objectUrlStore[urlId];
  asset.IDB_ITEM = true;
  return asset;
};

const fetchAndSetFile = async ({
  storeName,
  assetFetchFunc,
  id,
  version,
  file,
  file_window_door,
  is_windows_and_doors,
  rest,
}) => {
  let blob;
  let blobDoorWindows;
  if (assetFetchFunc) {
    blob = await assetFetchFunc({ file, file_window_door, is_windows_and_doors: false });
  } else {
    blob = await fetch(file).then((res) => res.blob());
  }

  if (file_window_door) {
    if (assetFetchFunc) {
      blobDoorWindows = await assetFetchFunc({
        file,
        file_window_door,
        is_windows_and_doors: true,
      });
    } else {
      blobDoorWindows = await fetch(file_window_door).then((res) => res.blob());
    }
  }

  const asset = {
    ...rest,
    id,
    version,
    file: blob,
    originalFileUrl: file,
    file_window_door: blobDoorWindows,
    originalWindowDoorFileUrl: file_window_door,
    is_windows_and_doors,
  };

  await updateAsset(storeName, asset);

  return asset;
};

export const getOrStoreAsset = async (storeName, data, { assetFetchFunc } = {}) => {
  const { id, version, file, file_window_door, is_windows_and_doors, ...rest } = data;

  if (rest.IDB_ITEM) {
    // it's item which was retrieved from idb, we don't need to store it
    return data;
  }

  let asset = await getAsset(storeName, id);

  const localFileUrlsAcive = selectLocalFileUrlsActive(getAppState());
  if (is_windows_and_doors && (!asset || !asset.file_window_door)) {
    asset = await fetchAndSetFile({
      storeName,
      assetFetchFunc,
      id,
      version,
      file,
      file_window_door,
      is_windows_and_doors,
      rest,
    });
  }
  
  if (
    asset &&
    asset.version === version &&
    (asset.updated_at !== rest.updated_at || !localFileUrlsAcive) 
  ) {
    // TODO: we can aslo check updated_at filed here?
    // data was already in indexdb and file wasn't changed -> simple update data without updating the blob file
    const updatedAsset = {
      ...rest,
      id,
      version,
      file: asset.file,
      file_window_door: asset.file_window_door,
      originalWindowDoorFileUrl: file_window_door,
      originalFileUrl: file,
      is_windows_and_doors,
    };
    await updateAsset(storeName, updatedAsset);
    asset = updatedAsset;
  } else if (!asset || !asset.file || asset.version !== version) {
    // data is not saved in indexdb or version was changed
    if (!file) throw new Error('File is missing. LF_999878');

    // let blob;
    // let blobDoorWindows;
    // if (assetFetchFunc) {
    //   blob = await assetFetchFunc({ file, file_window_door, is_windows_and_doors: false });
    // } else {
    //   blob = await fetch(file).then((res) => res.blob());
    // }

    // if (file_window_door) {
    //   if (assetFetchFunc) {
    //     blobDoorWindows = await assetFetchFunc({ file, file_window_door, is_windows_and_doors: true });
    //   } else {
    //     blobDoorWindows = await fetch(file_window_door).then((res) => res.blob());
    //   }
    // }

    // asset = {
    //   ...rest,
    //   id,
    //   version,
    //   file: blob,
    //   originalFileUrl: file,
    //   file_window_door: blobDoorWindows,
    //   originalWindowDoorFileUrl: file_window_door,
    //   is_windows_and_doors,
    // };

    // await updateAsset(storeName, asset);

    asset = await fetchAndSetFile({
      storeName,
      assetFetchFunc,
      id,
      version,
      file,
      file_window_door,
      is_windows_and_doors,
      rest,
    });
  }
  // if (asset.display_name === 'lr26_window_frame') {
  //   let data = normalizeAsset(asset, storeName);
  //   console.log(data, asset)
  // }

  return normalizeAsset(asset, storeName);
};

export const updateDbProp = (
  { id, name, version, product_file, is_windows_and_doors, product_file_window_door, ...rest },
  { assetFetchFunc } = {}
) => {
  return getOrStoreAsset(
    STORE.PROPS,
    {
      ...rest,
      id,
      name,
      version,
      product_file,
      product_file_window_door,
      file: product_file,
      file_window_door: product_file_window_door,
      is_windows_and_doors,
    },
    {
      assetFetchFunc,
    }
  );
};

export const updateDbTexture = ({
  id,
  name,
  version,
  texture_file,
  low_texture_file,
  file,
  ...rest
}) => {
  return getOrStoreAsset(STORE.TEXTURES, {
    ...rest,
    id,
    name,
    version,
    texture_file,
    low_texture_file,
    file: file || low_texture_file || texture_file,
  });
};

export const updateDbLowTexture = (
  { id, name, version, low_texture_file, texture_file, ...rest },
  additionalData
) => {
  return getOrStoreAsset(STORE.TEXTURES, {
    ...rest,
    id,
    name,
    version,
    low_texture_file,
    texture_file,
    file: low_texture_file || texture_file,
    IS_LOW_TEXTURE: true,
    ...additionalData,
  });
};

export const updateDbMaterial = ({ id, name, version, material_image, file, ...rest }) => {
  return getOrStoreAsset(STORE.MATERIALS, {
    ...rest,
    id,
    name,
    version,
    material_image,
    file: file || material_image,
  });
};

export const updateDbMaterialTextures = ({
  id,
  name,
  version,
  texture_file,
  low_texture_file,
  ...rest
}) => {
  return getOrStoreAsset(STORE.MATERIAL_TEXTURES_OLD, {
    ...rest,
    id,
    name,
    version,
    texture_file,
    low_texture_file,
    file: texture_file || low_texture_file,
  });
};

export const updateDbLayout = ({ id, display_name, version, webgl, webgl_window_door,  ...rest }) => {
  return getOrStoreAsset(STORE.LAYOUTS, {
    ...rest,
    id,
    name: display_name,
    version,
    webgl,
    file: webgl,
    file_window_door: webgl_window_door
  });
};

export const getTexture = async (id) => {
  const asset = await getAsset(STORE.TEXTURES, parseInt(id));
  return normalizeAsset(asset, STORE.TEXTURES);
};

export const getMaterial = async (id) => {
  const asset = await getAsset(STORE.MATERIALS, parseInt(id));
  return normalizeAsset(asset, STORE.MATERIALS);
};

export const getProp = async (id) => {
  const asset = await getAsset(STORE.PROPS, parseInt(id));
  return normalizeAsset(asset, STORE.PROPS);
};

export const getMaterialTexture = async (id) => {
  const asset = await getAsset(STORE.MATERIAL_TEXTURES_OLD, parseInt(id));
  return normalizeAsset(asset, STORE.MATERIAL_TEXTURES_OLD);
};

export const getProejctZip = async (id) => {
  let zipFileDetails = await getAsset(STORE.FILES, id);

  if (zipFileDetails) {
    if (!Array.isArray(zipFileDetails.curatorUuidList)) {
      zipFileDetails.curatorUuidList = [];
    }

    const curatorUuid = selectUuid(getAppState());
    if (!zipFileDetails.curatorUuidList.includes(curatorUuid)) {
      zipFileDetails.curatorUuidList.push(curatorUuid);
      await updateAsset(STORE.FILES, { ...zipFileDetails });
    }
  }

  return zipFileDetails;
};

export const setProjectZip = (file, uuid) => {
  const curatorUuid = selectUuid(getAppState());
  return updateAsset(STORE.FILES, {
    id: uuid,
    type: 'ZIP_FILE',
    curatorUuidList: [curatorUuid],
    file,
  });
};

// temp db store
export const addDefaultMaterial = async ({ file, key, textureName, materialId }) => {
  return await updateAsset(STORE.TEMP_FILES, {
    id: key,
    file,
    curatorUuid: selectUuid(getAppState()),
    textureName,
    materialId,
  });
};

export const getDefaultMaterial = (key) => {
  return getAsset(STORE.TEMP_FILES, key);
};

export const deleteDefaultMaterial = (key) => {
  return deleteAsset(STORE.TEMP_FILES, key);
};

export const cleanUpCuratorFiles = async (curatorUuid) => {
  // get all assets related to curator uuid and delete them
  const db = await getCuratorDB();
  const tempFiles = await db.getAllFromIndex(STORE.TEMP_FILES, INDEX.CURATOR_INDEX);

  tempFiles.forEach((file) => {
    if (file.curatorUuid !== curatorUuid) return;

    db.delete(STORE.TEMP_FILES, file.id);
  });
};

const getCuratorTempFiles = async () => {
  const db = await getCuratorDB();
  return db.getAllFromIndex(STORE.TEMP_FILES, INDEX.CURATOR_INDEX);
};

const getCuratorZipFiles = async () => {
  const db = await getCuratorDB();
  const files = await db.getAll(STORE.FILES);
  return files.filter(f => f.type === 'ZIP_FILE');
};


export const cleanUpCuratorFilesExcept = async (curatorList) => {
  // clean temp files
  const db = await getCuratorDB();
  const tempFiles = await getCuratorTempFiles();
  tempFiles.forEach((file) => {
    if (curatorList.includes(file.curatorUuid)) return;
    db.delete(STORE.TEMP_FILES, file.id);
  });

  // clean zip files
  const zipFiles = await getCuratorZipFiles();
  zipFiles.forEach(file => {

    if (Array.isArray(file.curatorUuidList)) {
      const curatorUuid = selectUuid(getAppState());
      const curatorListWithCurrentUuid = [...curatorList, curatorUuid];
      const stillActive = intersection(file.curatorUuidList, curatorListWithCurrentUuid)
      if (!stillActive.length) {
        db.delete(STORE.FILES, file.id);
      }
    } else {
      db.delete(STORE.FILES, file.id);
    }
  })
};

export const getDefaultTextureList = async ({ textureNameList }) => {
  const tempFiles = await getCuratorTempFiles();
  const objectTextures = tempFiles.filter((tempFile) =>
    textureNameList.includes(tempFile.textureName)
  );
  return objectTextures;
};

export const getAllFiles = async () => {
  const db = await getCuratorDB();
  let textures = await db.getAll(STORE.TEXTURES);
  let materials = await db.getAll(STORE.MATERIALS);
  let props = await db.getAll(STORE.PROPS);
  let layouts = await db.getAll(STORE.LAYOUTS);

  textures = textures.map((texture) => normalizeAsset(texture, STORE.TEXTURES));
  materials = materials.map((material) => normalizeAsset(material, STORE.MATERIALS));
  props = props.map((prop) => normalizeAsset(prop, STORE.PROPS));
  layouts = layouts.map((layout) => normalizeAsset(layout, STORE.LAYOUTS));

  console.log('IDB::getAllFiles', { textures, materials, props, layouts });
};


export const updateProjectAutoSave = async (data) => {
  return await updateAsset(STORE.PROJECT_AUTOSAVE, data);
}

export const getProjectAutoSave = async (id) => {
  return await getAsset(STORE.PROJECT_AUTOSAVE, id);
}

export const deleteProjectBackup = async (id) => {
  return await deleteAsset(STORE.PROJECT_AUTOSAVE, id);
}


export const uploadedFilesIDB = {
  uploadedFiles: openDB('uploaded_files', 1, {
    blocked: () => {
      // TODO: handle this case when first upgrade will be needed
      console.log(`Please close this app opened in other browser tabs.`);
    },
    blocking: () => {
      // TODO: handle this case when first upgrade will be needed
      console.log(`App is outdated, please close this tab`);
    },
    upgrade: (db, oldVersion, newVersion, transaction) => {
      db.createObjectStore(STORE.UPLOAD_FILES, { keyPath: 'id' });
    }
  })
}

export const getUploadedFilesIDB = () => uploadedFilesIDB.uploadedFiles;

export const getUploadedFiles = async (storeName, id) => {
  const db = await getUploadedFilesIDB();
  const asset = db.get(storeName, id);

  asset.IDB_ITEM = true;

  // assetStore[storeName][id] = asset;
  return asset;
};

export const updateUploadedFiles = async (storeName, data) => {
  const db = await getUploadedFilesIDB();
  await db.put(storeName, data);
};

export const deleteUploadedFile = async (storeName, id) => {
  const db = await getUploadedFilesIDB();
  db.delete(storeName, id);
};


export const getUploadedFileIDB = async (id) => {
  const asset = await getUploadedFiles(STORE.UPLOAD_FILES, id);
  return asset
};

export const addUploadedFilesIDB = async (data) => {
  updateUploadedFiles(STORE.UPLOAD_FILES, data)
}

export const clearAllUploadedFilesIDB = async () => {
  const db = await getUploadedFilesIDB();
  await db.clear(STORE.UPLOAD_FILES);
}

// Returns every persisted upload record. Used by the resume-on-load routine.
export const getAllUploadedFilesIDB = async () => {
  const db = await getUploadedFilesIDB();
  return db.getAll(STORE.UPLOAD_FILES);
};
// endregion

window.LFApp.idb = {
  getAsset,
  STORE,
  getAllFiles,
};
